import { render, staticRenderFns } from "./jihuoka.vue?vue&type=template&id=7fb6e140&scoped=true"
import script from "./jihuoka.vue?vue&type=script&lang=js"
export * from "./jihuoka.vue?vue&type=script&lang=js"
import style0 from "./jihuoka.vue?vue&type=style&index=0&id=7fb6e140&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb6e140",
  null
  
)

export default component.exports